import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { Auction } from 'atoms/icons/Auction';
import { InstantBuy } from 'atoms/icons/InstantBuy';
import { Transfer } from 'atoms/icons/Transfer';
import { Vertical } from 'atoms/layout/flex';
import { NavItem } from 'components/navigation/NavItem';
import {
  ANY_SPORT_MARKET_SHOP_AUCTIONS,
  ANY_SPORT_MARKET_SHOP_INSTANT_BUY,
  ANY_SPORT_MARKET_SHOP_MANAGER_SALES,
} from 'constants/__generated__/routes';
import { useSportContext } from 'contexts/sport';
import { useEvents } from 'lib/events/useEvents';
import { navLabels, transferMarket } from 'lib/glossary';
import { ClickMarketHoverMenuButton_Target } from 'protos/events/so5/shared/events';

const Root = styled(Vertical).attrs({ gap: 0.5 })`
  border-radius: var(--intermediate-unit);
  background-color: var(--c-black);
`;

type Props = { onClick?: () => void };

export const MarketNavItems = ({ onClick }: Props) => {
  const { formatMessage } = useIntl();
  const { generateSportContextPath, sport } = useSportContext();
  const track = useEvents();

  const onClickFn = (t: ClickMarketHoverMenuButton_Target) => {
    return () => {
      track('Click Market Hover Menu Button', {
        sport,
        target: t,
      });
    };
  };

  return (
    <Root onClick={onClick}>
      <NavItem
        icon={() => <Auction />}
        label={formatMessage(navLabels.auctions)}
        to={generateSportContextPath(ANY_SPORT_MARKET_SHOP_AUCTIONS)}
        onClick={onClickFn(ClickMarketHoverMenuButton_Target.AUCTIONS)}
      />
      <NavItem
        icon={() => <InstantBuy />}
        label={formatMessage(transferMarket.instantBuy)}
        to={generateSportContextPath(ANY_SPORT_MARKET_SHOP_INSTANT_BUY)}
        onClick={onClickFn(ClickMarketHoverMenuButton_Target.INSTANT_BUY)}
      />
      <NavItem
        icon={() => <Transfer />}
        label={formatMessage(transferMarket.transfer)}
        to={generateSportContextPath(ANY_SPORT_MARKET_SHOP_MANAGER_SALES)}
        onClick={onClickFn(ClickMarketHoverMenuButton_Target.MANAGER_SALES)}
      />
    </Root>
  );
};
